// DEBT-VITA™ — Bannière d'alerte vitaliste (4 niveaux)
import React from "react";
import { CheckCircle, AlertTriangle, AlertCircle, ShieldAlert } from "lucide-react";

const VARIANTS = {
  1: {
    Icon: CheckCircle,
    bg: "bg-emerald-50 border-emerald-300 dark:bg-emerald-950/40 dark:border-emerald-700",
    text: "text-emerald-900 dark:text-emerald-200",
    iconColor: "text-emerald-600 dark:text-emerald-400",
    title: "DETTE SOUTENABLE",
    body: "La charge vitaliste de la dette reste dans des limites compatibles avec la dignité des contribuables.",
    pulse: false,
  },
  2: {
    Icon: AlertTriangle,
    bg: "bg-yellow-50 border-yellow-300 dark:bg-yellow-950/40 dark:border-yellow-700",
    text: "text-yellow-900 dark:text-yellow-200",
    iconColor: "text-yellow-600 dark:text-yellow-400",
    title: "DETTE SOUS TENSION",
    body: "La charge vitaliste commence à peser significativement sur la liberté économique des citoyens.",
    pulse: false,
  },
  3: {
    Icon: AlertCircle,
    bg: "bg-orange-50 border-orange-300 dark:bg-orange-950/40 dark:border-orange-700",
    text: "text-orange-900 dark:text-orange-200",
    iconColor: "text-orange-600 dark:text-orange-400",
    title: "DETTE CRITIQUE",
    body: "Le niveau d'endettement atteint un seuil d'aliénation vitaliste préoccupant. Principe de proportionnalité menacé.",
    pulse: false,
  },
  4: {
    Icon: ShieldAlert,
    bg: "bg-red-50 border-red-400 dark:bg-red-950/50 dark:border-red-700",
    text: "text-red-900 dark:text-red-200",
    iconColor: "text-red-600 dark:text-red-400",
    title: "DETTE INSOUTENABLE",
    body: "L'endettement public constitue une violation du principe de proportionnalité vitale. Les générations futures sont hypothéquées sans leur consentement.",
    pulse: true,
  },
};

export default function DebtAlertBanner({ alertLevel }) {
  if (!alertLevel || !alertLevel.level) return null;
  const v = VARIANTS[alertLevel.level] || VARIANTS[1];
  const { Icon } = v;
  return (
    <div
      data-testid={`debt-alert-banner-level-${alertLevel.level}`}
      className={
        "flex items-start gap-3 rounded-xl border-2 p-4 " +
        v.bg +
        " " +
        (v.pulse ? "animate-pulse-soft" : "")
      }
      style={
        v.pulse
          ? { animation: "pulseSoft 2.4s ease-in-out infinite" }
          : undefined
      }
    >
      <Icon className={"mt-0.5 h-6 w-6 shrink-0 " + v.iconColor} />
      <div className={v.text}>
        <p className="text-xs font-extrabold uppercase tracking-widest">
          Niveau {alertLevel.level} —{" "}
          <span className="text-base font-black tracking-normal">{v.title}</span>
        </p>
        <p className="mt-1 text-sm leading-relaxed">{v.body}</p>
      </div>
      {v.pulse ? (
        <style>{`
          @keyframes pulseSoft {
            0%, 100% { box-shadow: 0 0 0 0 rgba(192, 57, 43, 0.45); }
            50% { box-shadow: 0 0 0 12px rgba(192, 57, 43, 0); }
          }
        `}</style>
      ) : null}
    </div>
  );
}
